import { Check, CalendarDays, Clock3, Users, Music2 } from 'lucide-react';

function formatDraftDate(value) {
  if (!value) return 'Data a definir';
  const [year, month, day] = String(value).slice(0, 10).split('-');
  return year && month && day ? `${day}/${month}/${year}` : value;
}

export default function ScheduleFormProgress({ steps, activeStep, onStepChange, formData }) {
  const progress = Math.round(((activeStep - 1) / (steps.length - 1)) * 100);

  return (
    <div className="mbv-schedule-progress">
      <div className="mbv-schedule-progress-top">
        <span>Montagem da escala</span>
        <strong>{progress}% concluído</strong>
      </div>
      <div className="mbv-schedule-progress-track"><span style={{ width: `${progress}%` }} /></div>
      <nav className="mbv-schedule-progress-steps" aria-label="Etapas da escala">
        {steps.map((label, index) => {
          const step = index + 1;
          return (
            <button
              type="button"
              key={label}
              className="mbv-schedule-progress-button"
              data-active={activeStep === step}
              data-complete={activeStep > step}
              aria-current={activeStep === step ? 'step' : undefined}
              onClick={() => onStepChange(step)}
            >
              <span>{activeStep > step ? <Check size={15} /> : String(step).padStart(2, '0')}</span>
              {label}
            </button>
          );
        })}
      </nav>
      <div className="mbv-schedule-draft-strip" aria-live="polite">
        <span><CalendarDays size={15} />{formatDraftDate(formData.date)}</span>
        <span><Clock3 size={15} />{formData.start_time || 'Horário a definir'}</span>
        <span><Users size={15} />{formData.members?.length || 0} integrantes</span>
        {steps.length === 4 && <span><Music2 size={15} />{formData.songs?.length || 0} hinos</span>}
      </div>
    </div>
  );
}

export function ScheduleDraftSummary({ formData, hasSongs }) {
  return (
    <div className="mbv-schedule-summary">
      <p className="mbv-schedule-summary-eyebrow">Prévia da escala</p>
      <h3>{formData.title?.trim() || 'Escala sem título'}</h3>
      <p>{formatDraftDate(formData.date)} · {formData.start_time || '--:--'}{formData.end_time ? ` às ${formData.end_time}` : ''}{formData.location ? ` · ${formData.location}` : ''}</p>
      <div className="mbv-schedule-summary-members">
        {formData.members?.length ? formData.members.map((member) => (
          <span key={member.id}>{member.name || member.full_name}<small>{member.role || 'Função pendente'}</small></span>
        )) : <em>Nenhum integrante selecionado.</em>}
      </div>
      {hasSongs && <p className="mbv-schedule-summary-songs">{formData.songs?.length || 0} hino(s) selecionado(s)</p>}
    </div>
  );
}
